import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react'

import analytics from 'APP_ROOT/services/analytics';
import errorReporting from 'APP_ROOT/services/errorReporting';
import App from './App';
import makeStore from './store';
import { unregister } from './registerServiceWorker';

import './components/common/polyfills.js';

analytics.initialize();
errorReporting.initialize();

const { store, persistor } = makeStore();

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <App />
        </PersistGate>
    </Provider>,
    document.getElementById('root'));
unregister();
